export default __webpack_public_path__ + "static/media/Outfit-Regular.e853df41.ttf";